export const SET_FILE = "SET_FILE";
export const SET_FILES = "SET_FILES";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_FILE_UPLOAD_STATUS = "SET_FILE_UPLOAD_STATUS";
export const REMOVE_FILE = "REMOVE_FILE";
export const REMOVE_ALL_FILES = "REMOVE_ALL_FILES";
export const REMOVE_MESSAGES = "REMOVE_MESSAGES";
